define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.GlobalLink = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  var _excluded = ["children", "title", "to", "globalUrl"];

  var GlobalLink = function GlobalLink(_ref) {
    var children = _ref.children,
        title = _ref.title,
        to = _ref.to,
        globalUrl = _ref.globalUrl,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
      title: title
    }, props, {
      href: "" + globalUrl + to
    }), children);
  };

  _exports.GlobalLink = GlobalLink;
  GlobalLink.defaultProps = {
    title: ''
  };
});